var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65881 0.901144L1.7342 0.964136L9.96877 9.19828L18.2033 0.964136C18.4159 0.751538 18.7606 0.751538 18.9732 0.964136C19.1622 1.15311 19.1832 1.44646 19.0362 1.65862L18.9732 1.73402L10.7391 9.96859L18.9732 18.2032C19.1858 18.4158 19.1858 18.7604 18.9732 18.973C18.7843 19.162 18.4909 19.183 18.2787 19.036L18.2033 18.973L9.96877 10.7389L1.7342 18.973C1.52161 19.1856 1.17692 19.1856 0.964319 18.973C0.775343 18.7841 0.754346 18.4907 0.901327 18.2786L0.964319 18.2032L9.19846 9.96859L0.964319 1.73402C0.751721 1.52142 0.751721 1.17673 0.964319 0.964136C1.12967 0.798782 1.37493 0.762037 1.5758 0.8539L1.65881 0.901144Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.24237fc4.svg";
export { ForwardRef as ReactComponent };